import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { getData, postData } from '../../services/api'
import { CircularProgress, IconButton, InputAdornment, TextField } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash, faLock } from '@fortawesome/free-solid-svg-icons'
import Swal from 'sweetalert2'

export default function ResetPassword() {
    const [searchParams, setSearchParams] = useSearchParams()
    let token = searchParams.get('token') || ''
    const [checked, setCecked] = useState(false)
    const [newPassword, setNewPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [errorConfirmPassword, setErrorConfirmPassword] = useState(false)
    const [loading, setLoading] = useState(false)

    const [confirmPassword, setConfirmPassword] = useState('')
    useEffect(() => {
        const checkToken = async () => {
            const url = `auth/check-reset-password-token?token=${token}`;
            getData(url).then((response) => {
                if (response.status === true) {
                    setCecked(false)
                } else {
                    setCecked(true)
                }
            })
        }
        checkToken()
    }, [])
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);
    const handleMouseDownConfirmPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const resetPassword = async () => {
            setLoading(true)
            const url = `auth/login-and-set-new-password`;
            const body = {
                Token: token,
                NewPassword: newPassword
            }
            postData(url, body).then((response) => {
                if (response.status === true) {
                    setLoading(false)
                    Swal.fire(
                        'ทำรายการสำเร็จ',
                        ``,
                        'success'
                    )
                    Swal.fire({
                        title: 'ทำรายการสำเร็จ',
                        icon: 'success',
                        confirmButtonColor: '#4ab866',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            localStorage.setItem("accessTR", response.result.AccessToken);
                            localStorage.setItem("refreshTR", response.result.RefreshToken);
                            window.location.href = '/'
                        }

                    })


                } else {
                    setLoading(false)
                    Swal.fire({
                        title: 'ทำรายการไม่สำเร็จ',
                        icon: 'warning',
                    })
                }
            })
        }
        if (!newPassword || !confirmPassword || confirmPassword !== newPassword) {
            Swal.fire({
                title: !newPassword ? 'กรุณาระบุรหัสผ่าน' : !confirmPassword ? 'กรุณายืนยันรหัสผ่าน' : confirmPassword !== newPassword ? 'กรุณายืนยันรหัสผ่านให้ตรงกับรหัสผ่านใหม่' : 'ทำรายการไม่สำเร็จ',
                icon: 'warning',
            })
        } else {
            resetPassword()
        }

    }
    return (
        <div className='container-login'>
            <div className='wrap-login'>
                {checked ?
                    <div className="text-center logo-row-btm">
                        <label className="font-logo">ไม่พบผู้ใช้ในระบบ</label>
                    </div> :
                    <>
                        <div className="text-center logo-row-top">
                            {/* <img src={img} className="logo-top" alt="" /> */}
                        </div>
                        <div className="text-center logo-row-btm">
                            <label className="font-logo" >กรุณาตั้งรหัสผ่านใหม่</label>
                        </div>
                        <form onSubmit={e => handleSubmit(e)}>
                            <div className="row">
                                <TextField variant="outlined"
                                    fullWidth
                                    required
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    placeholder='New Password'
                                    type={showPassword ? 'text' : 'password'}
                                    InputProps={{
                                        startAdornment:
                                            (<InputAdornment position="start">
                                                <FontAwesomeIcon icon={faLock} className='prefix-icon-input' />
                                            </InputAdornment>),
                                        endAdornment: (<InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
                                            </IconButton>
                                        </InputAdornment>),
                                    }} />

                            </div>
                            <div className="row">
                                <TextField variant="outlined"
                                    fullWidth
                                    required
                                    error={errorConfirmPassword}
                                    onBlur={() => {
                                        if (newPassword !== confirmPassword) {
                                            setErrorConfirmPassword(true)
                                        } else {
                                            setErrorConfirmPassword(false)
                                        }
                                    }}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder='Confirm Password'
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    InputProps={{
                                        startAdornment:
                                            (<InputAdornment position="start">
                                                <FontAwesomeIcon icon={faLock} className='prefix-icon-input' />
                                            </InputAdornment>),
                                        endAdornment: (<InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowConfirmPassword}
                                                onMouseDown={handleMouseDownConfirmPassword}
                                                edge="end"
                                            >
                                                {showConfirmPassword ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
                                            </IconButton>
                                        </InputAdornment>),
                                    }} />

                            </div>
                            <div className="row justify-content-center">
                                <button disabled={loading} className="login100-form-btn" type='submit'>
                                    {loading ? <CircularProgress color="inherit" size={25} /> : <span> ยืนยัน</span>}
                                </button>
                            </div>
                        </form>
                    </>}
            </div >
        </div >
    )
}
